import React, { FunctionComponent } from 'react'
import { TableRow, TableCell } from 'transfix-ui'
import { columns } from './columns'

export const StatusRow: FunctionComponent<JSX.ElementChildrenAttribute> = ({ children }) => (
  <TableRow>
    <TableCell colSpan={columns.length}>
      <div className='tc pa6'>{children}</div>
    </TableCell>
  </TableRow>
)
